var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375.4 392.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 207,
    y1: 155.9,
    x2: 207,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f14bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a00ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 187.7,
    y1: 392.1,
    x2: 187.7,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 189.4,
    y1: 139,
    x2: 189.4,
    y2: 92.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 197.1,
    y1: 142.5,
    x2: 197.1,
    y2: 115.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 41,
    y1: 193.6,
    x2: 41,
    y2: 161.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 89.3,
    y1: 193.6,
    x2: 89.3,
    y2: 161.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 41,
    y1: 236.6,
    x2: 41,
    y2: 204.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 89.3,
    y1: 236.6,
    x2: 89.3,
    y2: 204.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 41,
    y1: 279.8,
    x2: 41,
    y2: 247.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 89.3,
    y1: 279.8,
    x2: 89.3,
    y2: 247.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 138.5,
    y1: 279.8,
    x2: 138.5,
    y2: 247.7,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M202.5,152.5c1.3,2.2,3.6,3.4,6,3.4s2.5-.3,3.6-1c3.3-2,4.4-6.3,2.4-9.6l-3-4.9c-2-3.3-6.3-4.3-9.6-2.3-3.3,2-4.3,6.3-2.3,9.6l3,4.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.5,319.5h0c2.4-7.4,7.6-25.4,8.5-47.3,1.6-38-10.6-69.3-35.2-90.5,0,0-.1-.1-.2-.2l-43.3-34.2-48.8-84.5c-4.1-7.1-10.7-12.2-18.6-14.3-7.9-2.1-16.2-1-23.3,3.1l-23,13.3v-31.2c0-18.6-15.1-33.8-33.8-33.8H33.8C15.2,0,0,15.2,0,33.8v234c0,16.9,12.5,30.9,28.7,33.4v68.3c0,2.4,1.2,4.6,3.2,5.9,2,1.3,4.5,1.5,6.6.5l13.7-6,16.9,6.2c1.6.6,3.4.6,5,0l15.3-6.1,16.6,6.2c1.6.6,3.3.6,4.9,0l15.9-5.8,13.5,5.7c.9.4,1.8.5,2.7.5,1.4,0,2.7-.4,3.9-1.2,2-1.3,3.1-3.5,3.1-5.8v-68.3c16.2-2.5,28.7-16.5,28.7-33.4v-13.5c1.4,2.4,2.8,4.8,4.2,7.2,1.1,1.9,2.3,3.6,3.7,5.2-2.5,6.7-5.8,18.9-1.7,27.9,2.2,4.8,6.3,8.2,11.7,9.6,2.1.5,4.1.8,6.1.8,4.3,0,8.3-1.3,11.7-3.8,0,0,0,0,0,0,2.4,3.6,5.8,7,10.7,8.5,1.7.5,3.4.8,5.2.8,3.3,0,6.7-.9,10.1-2.8,8.6,28,22.4,47.4,41.2,57.8l10.1,22.4c1.2,2.6,3.7,4.1,6.4,4.1s1.9-.2,2.9-.6c3.5-1.6,5.1-5.7,3.5-9.2l-11.1-24.6c-.7-1.5-1.8-2.6-3.2-3.4-26-13.1-37-46.8-41.6-72.7-5.2-29.1-3.8-55.3-3.8-55.6,0-1.4-.3-2.8-1-4l-16-26.7s0,0,0,0c0-.1-8.1-13.8-1.6-18.8,5.5-4.3,11.2,1.3,12.8,3.1l14,23c2,3.3,6.3,4.3,9.6,2.3,3.3-2,4.3-6.3,2.3-9.6l-14.3-23.5c-.2-.3-.3-.5-.5-.8-6.2-7.7-20-15.5-32.5-5.7-7.1,5.5-9.5,14.2-6.9,24.6,1.6,6.5,4.7,11.7,5.2,12.5l14.9,24.9c-.2,4.1-.3,13.4.4,25.6l-13.4,7.8c-8,4.6-18.2,1.9-22.8-6.1-6.4-11-13-22.5-19.2-33.3-4.1-7.2-8.1-14.1-11.7-20.3-4.5-7.8-8.4-14.6-11.3-19.7l-11.4-19.9-7.2-12.5c-.2-.2-.3-.5-.4-.7-4.3-7.4-6.8-11.8-9.5-16.4-.8-1.4-3.3-6.5-1.7-12.6,1.1-4.3,3.9-7.9,7.8-10.1l22.8-13.2,55.7-32.2c3.8-2.2,8.3-2.8,12.6-1.7,4.3,1.1,7.9,3.9,10.1,7.8l49.4,85.5,21.4,37.1c2.2,3.8,2.8,8.3,1.7,12.6-1.1,4.3-3.9,7.9-7.8,10.1l-15.1,8.7-6.6-10.7c-2-3.3-6.3-4.3-9.6-2.3-3.3,2-4.3,6.3-2.3,9.6l18.5,30c1.3,2.1,3.6,3.3,6,3.3s2.5-.3,3.7-1c3.3-2,4.3-6.3,2.3-9.6l-4.5-7.4,14.8-8.5c7.1-4.1,12.2-10.7,14.3-18.6,2.1-7.9,1-16.2-3.1-23.3l-3.1-5.3,15.5,12.3c21.4,18.5,31.5,45,30.2,78.8-1,26-8.8,46.7-8.9,46.9-.8,2.2-.5,4.7.9,6.6,5.2,7.2,11.3,16.1,12.6,18.6.8,3,3.5,5.2,6.8,5.2s7-3.1,7-7,0-4-12.9-22ZM227.9,271l4.6-2.7c.6,5,1.3,10.1,2.2,15.4.6,3.4,1.2,6.6,2,9.8-3.1,2.3-5.7,3.3-7.4,2.8-2.4-.8-4.5-4.8-5.6-8,2.6-6.4,3.7-13.2,4.2-17.4ZM198.6,274.9c3.5,1.3,7.1,2,10.8,2s2.2,0,3.2-.2c-1.3,5.4-3.4,10.9-6.6,13.2-1.1.8-2.7,1.6-5.9.8-1.6-.4-2.2-1.1-2.6-1.9-1.4-3-.5-8.7,1-13.8ZM136,359l-6.4-2.7c-1.6-.7-3.5-.7-5.1-.1l-16,5.8-16.7-6.3c-.8-.3-1.6-.5-2.5-.5s-1.8.2-2.6.5l-15.3,6.2-17-6.2c-1.7-.6-3.6-.6-5.2.2l-6.5,2.9v-57.2h93.3v57.4ZM142.5,85.9l-19.3,11.1c-1.8,1-3.4,2.2-4.9,3.5h0c-4.5,4-7.8,9.2-9.4,15.1-.2.7-.3,1.3-.5,1.9,0,.2,0,.4-.1.6,0,.4-.2.8-.2,1.3,0,.2,0,.5,0,.7,0,.4,0,.8-.1,1.1,0,.2,0,.5,0,.7,0,.4,0,.7,0,1.1v.7c0,.4,0,.8,0,1.1,0,.2,0,.4,0,.5,0,.5,0,1,.1,1.5,0,0,0,0,0,.1,0,.5.1,1,.2,1.4H36V54.7h106.5v31.2ZM164.6,73.1l-8.2,4.7v-30.1c0-3.9-3.1-7-7-7H29c-3.9,0-7,3.1-7,7v87.8c0,3.9,3.1,7,7,7h85.1c2.1,3.7,4.4,7.7,7.9,13.6l4.1,7.1,3.1,5.4,11.4,19.8c.4.7.8,1.4,1.3,2.2,2.5,4.4,5.7,9.9,9.2,16-1.8-1.2-3.9-1.9-6.2-1.9h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11h12.5c6.1,0,11-4.9,11-11v-10.1c0-.3,0-.6,0-.9,2.5,4.3,5.1,8.9,7.9,13.6.4.6.7,1.2,1.1,1.9v37.7h0c0,10.9-8.9,19.8-19.8,19.8H33.8c-10.9,0-19.8-8.9-19.8-19.8V33.8c0-10.9,8.9-19.8,19.8-19.8h111.1c10.9,0,19.8,8.9,19.8,19.8v39.3ZM144.8,215.6v10.1h-12.5v-10.1h12.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.4,102.9h0c.9-3.8-1.5-7.5-5.3-8.4-24.9-5.5-40.6,4.5-49.5,13.8-9.3,9.9-12.9,21.1-13,21.5-1.1,3.7.9,7.6,4.6,8.8.7.2,1.4.3,2.1.3,3,0,5.8-1.9,6.7-4.9.4-1.4,10.9-33.7,46.1-25.9,3.8.8,7.5-1.5,8.3-5.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.3,130.1h0c3.8.8,7.5-1.5,8.3-5.3.8-3.8-1.5-7.5-5.3-8.3-18.1-4-27.4,9.3-29.7,16.9-1.1,3.7.9,7.7,4.6,8.8.7.2,1.4.3,2.1.3,3,0,5.7-1.9,6.6-4.9.8-2.3,4-9.5,13.3-7.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M34.8,193.6h12.5c6.1,0,11-4.9,11-11v-10.1c0-6.1-4.9-11-11-11h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11ZM34.8,172.6h12.5v10.1h-12.5v-10.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.1,193.6h12.5c6.1,0,11-4.9,11-11v-10.1c0-6.1-4.9-11-11-11h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11ZM83.1,172.6h12.5v10.1h-12.5v-10.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.8,236.6h12.5c6.1,0,11-4.9,11-11v-10.1c0-6.1-4.9-11-11-11h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11ZM34.8,215.6h12.5v10.1h-12.5v-10.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.1,236.6h12.5c6.1,0,11-4.9,11-11v-10.1c0-6.1-4.9-11-11-11h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11ZM83.1,215.6h12.5v10.1h-12.5v-10.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.8,279.8h12.5c6.1,0,11-4.9,11-11v-10.1c0-6.1-4.9-11-11-11h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11ZM34.8,258.7h12.5v10.1h-12.5v-10.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.1,279.8h12.5c6.1,0,11-4.9,11-11v-10.1c0-6.1-4.9-11-11-11h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11ZM83.1,258.7h12.5v10.1h-12.5v-10.1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M132.3,279.8h12.5c6.1,0,11-4.9,11-11v-10.1c0-6.1-4.9-11-11-11h-12.5c-6.1,0-11,4.9-11,11v10.1c0,6.1,4.9,11,11,11ZM132.3,258.7h12.5v10.1h-12.5v-10.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.9425a2446433c95b9236abbbebc6c743.svg";
export { ForwardRef as ReactComponent };